var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVinylGoods(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.7C7.78783 7.7 7.58434 7.78429 7.43431 7.93431C7.28429 8.08434 7.2 8.28783 7.2 8.5C7.2 8.71217 7.28429 8.91566 7.43431 9.06569C7.58434 9.21571 7.78783 9.3 8 9.3C8.21217 9.3 8.41566 9.21571 8.56569 9.06569C8.71571 8.91566 8.8 8.71217 8.8 8.5C8.8 8.28783 8.71571 8.08434 8.56569 7.93431C8.41566 7.78429 8.21217 7.7 8 7.7ZM8 12.1C6 12.1 4.4 10.5 4.4 8.5C4.4 6.5 6 4.9 8 4.9C10 4.9 11.6 6.5 11.6 8.5C11.6 10.5 10 12.1 8 12.1ZM8 0.5C6.94943 0.5 5.90914 0.706926 4.93853 1.10896C3.96793 1.511 3.08601 2.10028 2.34315 2.84315C0.842855 4.34344 0 6.37827 0 8.5C0 10.6217 0.842855 12.6566 2.34315 14.1569C3.08601 14.8997 3.96793 15.489 4.93853 15.891C5.90914 16.2931 6.94943 16.5 8 16.5C10.1217 16.5 12.1566 15.6571 13.6569 14.1569C15.1571 12.6566 16 10.6217 16 8.5C16 7.44943 15.7931 6.40914 15.391 5.43853C14.989 4.46793 14.3997 3.58601 13.6569 2.84315C12.914 2.10028 12.0321 1.511 11.0615 1.10896C10.0909 0.706926 9.05058 0.5 8 0.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinylGoods);
export default __webpack_public_path__ + "static/media/vinylGoods.915e0989c1c4f60619aab4285471f8f7.svg";
export { ForwardRef as ReactComponent };